module.exports = __webpack_public_path__ + "icons/original/small/small-b2.1e0362bc91fe36a746482f52eea6cd78.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-b2.png
// module id = 6b+j
// module chunks = app